import React, { useState } from 'react';
import DownloadableReportTable from '../DownloadableReportTable';
import { getService } from '@Client/runner.hooks/useService';
import TagsReportFilter from '@Shared.Angular/@types/core/contracts/queryModel/reports/tagsReportFilter';

const TagReportsTab = () => {
  const APP_CONFIG = getService('APP_CONFIG');
  const [filter, setFilter] = useState<TagsReportFilter>(TagsReportFilter.ALL);

  const flowModelReports = [
    {
      name: 'Flow Model Tags',
      description: 'Tags and the Flow Models they are assigned to.',
      url: `${APP_CONFIG.apiBaseUrl}reports/tags/flowmodels/csvV2`,
      parameters: { tagsReportFilter: filter }
    },
    {
      name: 'Flow Model Step Tags',
      description: 'Tags and the Flow Model Steps they are assigned to.',
      url: `${APP_CONFIG.apiBaseUrl}reports/tags/steps/csvV2`,
      parameters: { tagsReportFilter: filter }
    }
  ];

  const filterOptions = [
    {
      id: 'processmap',
      label: 'Process Maps',
      value: TagsReportFilter.PROCESS_MAPS
    },
    { id: 'workflow', label: 'Workflows', value: TagsReportFilter.WORKFLOWS },
    { id: 'all', label: 'All', value: TagsReportFilter.ALL }
  ];

  const showFilterOptions =
    APP_CONFIG.allowWorkflow && APP_CONFIG.allowProcessMap;

  const otherReports = [
    {
      name: 'SOP Tags',
      description: 'Tags and the SOPs they are assigned to.',
      url: `${APP_CONFIG.apiBaseUrl}reports/tags/procedures/csvV2`
    }
  ];

  return (
    <div className="tag-reports">
      {APP_CONFIG.enableProcedures && (
        <DownloadableReportTable reports={otherReports} />
      )}
      <div>
        {showFilterOptions && (
          <div>
            <label>Filter by Flow Model Type:</label>
            <ul className="filter">
              {filterOptions.map((option) => (
                <li key={option.id}>
                  <input
                    type="radio"
                    name="filter"
                    id={option.id}
                    value={option.value}
                    checked={filter === option.value}
                    onChange={() => setFilter(option.value)}
                  />
                  <label htmlFor={option.id}>{option.label}</label>
                </li>
              ))}
            </ul>
          </div>
        )}
        <DownloadableReportTable reports={flowModelReports} />
      </div>
    </div>
  );
};

export default TagReportsTab;
